module.exports = __webpack_public_path__ + "static/media/About_Img_2.56509bf9.png";